import React from "react";


export default function MainTitle({ myJSON, emulatorStep, overview }) {
	return (
		<div
			className="info-title"
			style={{
				// myJSON.title.main_title.margin
				//   ? myJSON.title.main_title.margin
				//   : null,
				display: "inherit",
				// width: "1000px",

				marginBottom: "-40px"
				
			}}>
			<div
				style={{
					backgroundColor: "#c20839",
					height: "31px",
					width: "102px",
					marginRight: "20px"
				}}></div>
			<p
			class="flexed-title"
				style={{
					// fontSize: "3.5rem",
					fontFamily: myJSON.title.main_title.font_family ? myJSON.title.main_title.font_family : null,
					color: myJSON.title.main_title.color ? myJSON.title.main_title.color : null,
					width: myJSON.title.main_title.width ? myJSON.title.main_title.width : null,
					lineHeight: window.navigator.platform.includes("Win") ? "40px" : null,
					margin: window.navigator.platform.includes("Win") ? "0" : "-5px 0 0 0",
					zIndex: "400",
					whiteSpace: "nowrap",
					display: "inline",
				}}>
				{myJSON.title.main_title.text}
			</p>
			{myJSON.title.main_title.sim_text ? (
				<>
					<div
						style={{
							height: "50px",
							width: "4px",
							backgroundColor: "#c20839",
							margin: "-1px 10px 0 10px",
						}}></div>
					<p
						style={{
							color:
								myJSON.steps &&
								myJSON.steps[emulatorStep] &&
								myJSON.steps[emulatorStep].custom_overlay &&
								myJSON.steps[emulatorStep].custom_overlay.sim_text_color
									? myJSON.steps[emulatorStep].custom_overlay.sim_text_color
									: myJSON.title.main_title.sim_text_color,
							fontSize: myJSON.title.main_title.font_size,
							fontFamily: myJSON.title.main_title.font_family ? myJSON.title.main_title.font_family : null,
							margin: window.navigator.platform.includes("Win") ? " -4px 0 0 0" : "4px 0 0 0",
							display: "inline",
							whiteSpace: "nowrap",
						}}>
						{myJSON.title.main_title.sim_text}
					</p>
				</>
			) : null}
		</div>
	);
}
